import { ExceptionTarget } from "~/components/exceptions/types";
import { ExceptionMutationAction } from "~/operations";

export const targetLabelMap: Record<ExceptionTarget, string> = {
  check: "check",
  control: "control",
  asset: "asset",
  advisory: "advisory",
  cve: "vulnerability",
  finding: "finding",
  framework: "framework",
  policy: "policy",
};

export const NO_RISK_EXCEPTION: ExceptionMutationAction[] = [
  ExceptionMutationAction.RiskAccepted,
  ExceptionMutationAction.Workaround,
  ExceptionMutationAction.FalsePositive,
  ExceptionMutationAction.Disable,
];
